import Icon from '@/shared/components/Icon/Icon';
import { IonButton, IonLabel } from '@ionic/react';
import { Trans, useTranslation } from 'react-i18next';
import styles from './TradingBlocker.module.css';

type Props = {
  dueDiligence?: boolean;
};

const TradingBlocker: React.FC<Props> = ({ dueDiligence }) => {
  const { t } = useTranslation();
  const verifyTitle = dueDiligence
    ? t('wallets.restricted.due.diligence.title')
    : t('wallets.restricted.cta.title.hybrid');

  return (
    <>
      <div className={`${dueDiligence ? styles.inlineContainer : styles.modalContainer}`}>
        <div className={styles.rounded}>
          <Icon src={`assets/icons/person-outline.svg`} size="xlLarge" color="primary" />
          <div className={styles.icon}>
            <Icon
              src={`assets/icons/${dueDiligence ? 'warning' : 'checkmark'}-circle.svg`}
              size="medium"
              color="success"
            />
          </div>
        </div>
        <IonLabel className={styles.verifyTitle}>{verifyTitle}</IonLabel>
        {dueDiligence && (
          <IonLabel className={styles.verifyText}>
            <Trans i18nKey="wallets.restricted.due.diligence.text" />
          </IonLabel>
        )}

        {!dueDiligence && (
          <IonButton
            shape="round"
            onClick={() => {
              // TODO: BTF-4544, KYC
              console.log('TODO: BTF-4544, KYC');
            }}
          >
            <p className={styles.buttonText}>{t('videoident.request.link')}</p>
          </IonButton>
        )}
      </div>
    </>
  );
};

export default TradingBlocker;
